import { StyleSheet, TouchableOpacity, View } from 'react-native';
import FastImage from '@d11/react-native-fast-image';
import { mvs } from 'react-native-size-matters';

import { useAppSelector } from '../../app/hooks';
import { COLORS, IS_WEB, isTablet } from '../../constants';
import {
  selectDefaultCover,
  selectDivRadius,
} from '../../features/appconfig/store/selectors';
import { useAdjustedFontSize } from '../../hooks/useAdjustedFontSize';
import i18n from '../../localization/i18n';
import { CustomIcon } from '../CustomIcon';
import CustomText from '../CustomText';

interface EpisodeHeaderNavProps {
  podcastThumbnail: string;
  podcastName: string;
  onBackPress: () => void;
  onMenuPress: () => void;
  onPodcastPress?: () => void;
}

export function EpisodeHeaderNav({
  podcastThumbnail,
  podcastName,
  onBackPress,
  onMenuPress,
  onPodcastPress,
}: EpisodeHeaderNavProps) {
  const divRadius = useAppSelector(selectDivRadius);
  const defaultCover = useAppSelector(selectDefaultCover);
  const podcastNameFontSize = useAdjustedFontSize(mvs(16));
  const returnTextFontSize = useAdjustedFontSize(mvs(14));

  return (
    <View style={styles.header}>
      {/* back button */}
      <TouchableOpacity style={styles.returnLink} onPress={onBackPress}>
        <CustomIcon name="back" size={24} color={COLORS.WHITE} />
        {isTablet && (
          <CustomText
            weight="SemiBold"
            style={[styles.returnText, { fontSize: returnTextFontSize }]}
          >
            {i18n.t('podcast.goBack')}
          </CustomText>
        )}
      </TouchableOpacity>
      {/* podcast info row */}
      {!isTablet && (
        <TouchableOpacity style={styles.podcastInfoRow} onPress={onPodcastPress}>
          <FastImage
            source={podcastThumbnail ? { uri: podcastThumbnail } : defaultCover}
            style={[styles.podcastThumbnail, { borderRadius: mvs(divRadius) }]}
            resizeMode={FastImage.resizeMode.cover}
          />
          <CustomText
            style={[styles.podcastName, { fontSize: podcastNameFontSize }]}
            weight="SemiBold"
            numberOfLines={2}
          >
            {podcastName}
          </CustomText>
        </TouchableOpacity>
      )}
      {/* contextual menu button */}
      {IS_WEB ? (
        <View style={styles.menuIconContainer}>
          <CustomIcon name="podcastMenu" size={24} color={COLORS.WHITE} />
        </View>
      ) : (
        <TouchableOpacity onPress={onMenuPress} style={styles.menuIconContainer}>
          <CustomIcon name="podcastMenu" size={24} color={COLORS.WHITE} />
        </TouchableOpacity>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '100%',
  },
  returnLink: {
    flexDirection: 'row',
    gap: mvs(8),
    alignItems: 'center',
  },
  returnText: {
    color: COLORS.WHITE,
  },
  podcastInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: IS_WEB ? '65%' : '50%',
    gap: mvs(12),
    marginHorizontal: mvs(12),
  },
  podcastThumbnail: {
    width: mvs(40),
    height: mvs(40),
  },
  podcastName: {
    color: COLORS.WHITE,
  },
  menuIconContainer: {
    width: mvs(44),
    height: mvs(44),
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.20)',
    borderRadius: mvs(22),
  },
});
